export default "__VITE_ASSET__1WdnoMjddOtjty4hFToaIA__";